/**
 * Like Service
 */

DM.Service.Likes = (function () {
    var endpoint = {
        like: '/profile/AddLike',
        unlike: '/profile/RemoveLike',
        userLikes: '/profile/UserLikes',
    };

    return {
        like: function (id) {
            const formData = new FormData();
            formData.append('id', id)
            return fetch(endpoint.like, {
                method: 'POST',
                body: formData
            }).then(response => response.json());
        },
        unlike: function (id) {
            const formData = new FormData();
            formData.append('id', id)
            return fetch(endpoint.unlike, {
                method: 'POST',
                body: formData
            }).then(response => response.json());
        },
        getUserLikes: function (ids) {
            const formData = new FormData();
            formData.append('ids', JSON.stringify(ids))
            return fetch(endpoint.userLikes, {
                method: 'POST',
                body: formData
            }).then(response => response.json());
        },
    };

})();
